let header, headerSearchInput, headerSearchTrigger, focusTimeout, activeSearchClass;
// Active class
activeSearchClass = 'search-active';

export function setSearchTriggerState(trigger, isExpanded) {
    trigger.setAttribute('aria-expanded', String(isExpanded));

    const searchName = trigger.querySelector('[data-hs-name-search]');
    const closeName = trigger.querySelector('[data-hs-name-close]');

    if( searchName !== null ) {
        searchName.hidden = isExpanded;
    }

    if( closeName !== null ) {
        closeName.hidden = !isExpanded;
    }
}

function setSearchTriggerStates(isExpanded) {
    headerSearchTrigger.forEach((trigger) => {
        setSearchTriggerState(trigger, isExpanded);
    });
}

function triggerCallback(event) {
    if( !header.classList.contains(activeSearchClass) ) {
        return expandSearch();
    } else if ( header.classList.contains(activeSearchClass) ) {
        return hideSearch(event.currentTarget);
    }
}

function expandSearch() {
    header.classList.add(activeSearchClass);
    setSearchTriggerStates(true);
    clearTimeout(focusTimeout);
    focusTimeout = setTimeout(setInputFocus, 250);
}

function setInputFocus() {
    headerSearchInput.focus();
}

function hideSearch(trigger) {
    clearTimeout(focusTimeout);
    header.classList.remove(activeSearchClass);
    setSearchTriggerStates(false);
    headerSearchInput.blur();
    trigger.focus();
}

function init() {
    header = document.querySelector('header[data-header-search]');

    // We make sure header tag that wraps the whole header && has data attrib. [data-header-search].
    if( header !== null ) {
        headerSearchInput = header.querySelector('[data-hs-input]');
        headerSearchTrigger = header.querySelectorAll('[data-hs-trigger]');

        if( headerSearchInput === null || headerSearchTrigger.length === 0 ) {
            return;
        }

        headerSearchTrigger.forEach((trigger) => {
            setSearchTriggerState(trigger, false);
            trigger.addEventListener('click', triggerCallback);
        });
    }
}

export default init
